/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ amount: NonNullable<unknown> }} Refund_Max_HintInputs */

const vi_refund_max_hint = /** @type {(inputs: Refund_Max_HintInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Khách đã trả thừa ${i?.amount} trên đơn này.`)
};

/**

* @param {Refund_Max_HintInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const refund_max_hint = /** @type {((inputs: Refund_Max_HintInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Refund_Max_HintInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_refund_max_hint(inputs)
});